import React from 'react';
import Banner from './Banner';
import Header from './Header';
import About from './About';
import Description from './Description';
import Localisation from './Localisation';
import Offers from './Offers';

import styles from './MerchantProfil.module.css';

const MerchantProfil = ({ merchant, history, setHistory, setWindow, setPopUp }) => {
    const bannerUrl = (`${process.env.REACT_APP_BACKEND_URL}/uploads/bannerTrader${merchant?.id || 0}.jpeg`);
    const logoUrl = (`${process.env.REACT_APP_BACKEND_URL}/uploads/logoTrader${merchant?.id || 0}.jpeg`);

    return (
        <div className={styles.layout}>
            <Banner bannerUrl={bannerUrl} />
            <section className={styles.profil}>
                <Header logoUrl={logoUrl} company={merchant.company} />
                <About merchant={merchant} />
                <Description description={merchant.description} />
                <Offers id={merchant.id} history={history} setHistory={setHistory} setWindow={setWindow} setPopUp={setPopUp} />
                <Localisation company={merchant.company} lat={merchant.latitude} lon={merchant.longitude} />
            </section>
        </div>
    );
};

export default MerchantProfil;